// extracted by mini-css-extract-plugin
export var buttonDiscover = "cardAgenda-module--buttonDiscover--0956d";
export var buttonLink = "cardAgenda-module--buttonLink--dfc8e";
export var cat = "cardAgenda-module--cat--33136";
export var content = "cardAgenda-module--content--bbc70";
export var data = "cardAgenda-module--data--4d885";
export var date = "cardAgenda-module--date--8e7c9";
export var heart = "cardAgenda-module--heart--1c3dc";
export var hideOverflow = "cardAgenda-module--hideOverflow--0bdb6";
export var imageWrapper = "cardAgenda-module--imageWrapper--b78df";
export var likeWrapper = "cardAgenda-module--likeWrapper--653d0";
export var link = "cardAgenda-module--link--a5f01";
export var location = "cardAgenda-module--location--ae3ea";
export var logoWrapper = "cardAgenda-module--logoWrapper--23aad";
export var title = "cardAgenda-module--title--11b10";
export var wrapper = "cardAgenda-module--wrapper--aeed7";